import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './services/Routes';
import './style.css';

ReactDOM.render(<Routes />, document.getElementById('root'));


